import { jsxs as a, jsx as s } from "react/jsx-runtime";
import e from "./roche-stage-home-teaser.module.scss.js";
const l = ({
  teaserTitle: t,
  teaserDescription: r,
  headingLevel: o = 2,
  children: m
}) => {
  const c = `h${o}`;
  return /* @__PURE__ */ a("div", { className: e["stage-home-teaser"], children: [
    /* @__PURE__ */ a("div", { className: e["stage-home-teaser__top-wrapper"], children: [
      /* @__PURE__ */ s(c, { className: e["stage-home-teaser__title"], children: t }),
      /* @__PURE__ */ s("p", { className: e["stage-home-teaser__description"], children: r })
    ] }),
    /* @__PURE__ */ s("div", { className: e["stage-home-teaser__button-wrapper"], children: m })
  ] });
};
export {
  l as RocheUIStageHomeTeaser
};
